import * as Effect$dUncurried from "../Effect.Uncurried/index.js";
import * as Specular$dInternal$dProfiling from "../Specular.Internal.Profiling/index.js";
const measure = dictMonadEffect => {
  const Monad0 = dictMonadEffect.Monad0();
  const Bind1 = Monad0.Bind1();
  const pure1 = Monad0.Applicative0().pure;
  if (Specular$dInternal$dProfiling.enabled) {
    return name => action => Bind1.bind(dictMonadEffect.liftEffect(() => Specular$dInternal$dProfiling.begin(name)))(mark => Bind1.bind(action)(result => Bind1.bind(dictMonadEffect.liftEffect(() => Specular$dInternal$dProfiling.end(mark)))(() => pure1(result))));
  }
  return v => action => action;
};
const end = Specular$dInternal$dProfiling.enabled ? /* #__PURE__ */ Effect$dUncurried.runEffectFn1(Specular$dInternal$dProfiling.end) : v => () => {};
const begin = Specular$dInternal$dProfiling.enabled
  ? /* #__PURE__ */ Effect$dUncurried.runEffectFn1(Specular$dInternal$dProfiling.begin)
  : v => () => Specular$dInternal$dProfiling.none;
export {begin, end, measure};
